import { UserType } from './user';

export interface UserTypeOption {
  type: UserType;
  title: string;
  subtitle: string;
}

export const getUserTypeOptions = (): UserTypeOption[] => [
  {
    type: UserType.RESIDENT,
    title: "I'm a resident",
    subtitle: "I'd like to manage my account and invite people to make payments on my behalf.",
  },
  {
    type: UserType.GUEST,
    title: "I'm not a resident",
    subtitle: "I'd like to make a payment on behalf of a resident.",
  },
];

export const isResident = (userType: UserType): boolean => {
  return userType === UserType.RESIDENT;
};

export const isNonResident = (userType: UserType): boolean => {
  return userType !== UserType.RESIDENT;
};
